// extracted by mini-css-extract-plugin
export var fadeInOut = "_33-3";
export var icon = "_33-4";
export var savedIndicator = "_33-2";
export var savingIndicator = "_33-0";
export var spin = "_33-1";